import React from 'react'
import { FaTelegramPlane } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'

export default function Footer() {
  return <footer className='px-[5vw] py-[5vw] md:mt-[5vw] mt-[12vw] relative'>
    <div className='grid md:grid-cols-2 grid-cols-1 gap-10 relative z-50 bg p-10 rounded-3xl'>
      <div className='space-y-5'>
        <img src="/images/logo.png" alt="" className='md:w-[15vw] w-[50vw]' />
        <p className='md:text-base text-sm'>Stay in control while the AI optimizes your portfolio 24/7
<br /><br />
Let AI trade for you. Our system monitors top-performing assets, analyzes real-time data, and executes trades based on your custom settings—like risk level, trade limits, and capital allocation.
        </p>

      </div>
      <div className='grid  grid-cols-2  gap-10'>
        <div>
          <h2 className='text-xl'>Sections</h2>
          <div className='flex  flex-col md:gap-2 gap-3 flex-wrap opacity-80 md:text-lg text-sm mt-5'>
            <a href="#About" className='block'>About</a>
            <a href="#Home" className='block'>Features</a>
            <a href="#Tokenomics" className='block'>Tokenomics</a>
            <a href="#Roadmap" className='block'>Why Vocal AI?</a>
            <a href="#Advantages" className='block'>Advantages</a>
          </div>
        </div>
        <div className='flex items-center flex-col'>
          <h2 className='text-xl'>Socials</h2>
          <div className='flex items-center md:gap-5 gap-3 flex-wrap opacity-80 md:text-lg text-sm mt-5'>
            <a href="x.com/VocalAiETH">
              <FaXTwitter />
            </a>
            <a href="https://t.me/VocalAiPortal">
              <FaTelegramPlane />
            </a>
          </div>
        </div>
      </div>

    </div >
    <hr className='border-gray-500 my-5' />
    <p className='text-gray-500 text-center'>Copyright © 2025 Vocal AI. All Rights Reserved</p>
  </footer >
}  
